const PaperPlaneIcon = ({ color = '#fff', width = '22', height = '22', className }) => {

    return (
        <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.5 3.5L3.5 10.2l6.2 2.4m10.8-9.1L13.6 20.5l-3.9-7.9m10.8-9.1L9.7 12.6" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )

};

export default PaperPlaneIcon;
